import 'uikit/dist/js/uikit.min.js'



// WEBPACK FOOTER //
// ./scripts/modules/accoridon.js